import { render, staticRenderFns } from "./ProfitCenter.vue?vue&type=template&id=20b2d80c"
import script from "./ProfitCenter.vue?vue&type=script&lang=js"
export * from "./ProfitCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports